import { useCallback } from 'react';
import { atom, useAtom } from 'jotai';
import type { PolygonType } from '../../types/domain';

type CreatingCustomArea =
  | {
      type: Exclude<PolygonType, 'walking'>;
      minutes?: never;
    }
  | {
      type: 'walking';
      minutes: number;
    };

type UseCustomAreaCreation = {
  creatingCustomArea: CreatingCustomArea | null;
  startCustomAreaCreation: (type: PolygonType) => void;
  editCustomArea: (data: Partial<Omit<CreatingCustomArea, 'type'>>) => void;
  endCustomAreaCreation: () => void;
};

const creatingCustomAreaAtom = atom<CreatingCustomArea | null>(null);

const useCustomAreaCreation = (): UseCustomAreaCreation => {
  const [creatingCustomArea, setCreatingCustomArea] = useAtom(
    creatingCustomAreaAtom
  );

  const startCustomAreaCreation = useCallback(
    (type: PolygonType): void => {
      if (type === 'walking') {
        setCreatingCustomArea({ type: 'walking', minutes: 5 });
      } else {
        setCreatingCustomArea({ type: type });
      }
    },
    [setCreatingCustomArea]
  );

  const editCustomArea = useCallback(
    (data: Partial<Omit<CreatingCustomArea, 'type'>>): void => {
      if (creatingCustomArea && creatingCustomArea.type === 'walking') {
        setCreatingCustomArea({ ...creatingCustomArea, ...data });
      }
    },
    [creatingCustomArea, setCreatingCustomArea]
  );

  const endCustomAreaCreation = useCallback((): void => {
    setCreatingCustomArea(null);
  }, [setCreatingCustomArea]);

  return {
    creatingCustomArea,
    startCustomAreaCreation,
    editCustomArea,
    endCustomAreaCreation,
  };
};

export { useCustomAreaCreation };
